// setInterval that pauses while the tab is hidden and ticks once on return, so whatever it
// drives snaps current. Returns the stop function, to hand to onDestroy or an effect's onCleanup.
export function visibleInterval(ms: number, tick: () => void): () => void {
  let timer: ReturnType<typeof setInterval> | null = document.hidden ? null : setInterval(tick, ms);
  const onVisibility = () => {
    if (document.hidden) {
      if (timer !== null) clearInterval(timer);
      timer = null;
    } else if (timer === null) {
      tick();
      timer = setInterval(tick, ms);
    }
  };
  document.addEventListener('visibilitychange', onVisibility);
  return () => {
    if (timer !== null) clearInterval(timer);
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
